var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsBoolean, IsEnum, IsUUID } from 'class-validator';
import { SecondFactorResetScope } from '../../auth/second-factor-reset.js';
/**
 * `BACKEND_RESET_SECOND_FACTOR`: take a second factor away (TM-9636 / #1627).
 *
 * ⚠ **The backend decides who may do that.** The Java handler is the hand, not
 * the judge: it checks neither role nor Standort. Every caller of this path
 * stands in `reset-second-factor-callers.spec.ts`.
 *
 * The password stays untouched. A reset that took it along would turn a lost
 * phone into a locked-out colleague — exactly what this slice is meant to
 * prevent.
 */
export class BackendResetSecondFactorDto {
    keycloakUserId;
    scope;
    /**
     * End every open session too.
     *
     * ⚠ **The lock notice, not an ADMIN's reset.** Whoever reports their device
     * lost reports the sessions on it lost as well; an ADMIN who resets a
     * colleague's factor does not throw them out of the middle of scheduling for
     * it.
     */
    endSessions;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], BackendResetSecondFactorDto.prototype, "keycloakUserId", void 0);
__decorate([
    IsEnum(SecondFactorResetScope),
    Expose(),
    __metadata("design:type", String)
], BackendResetSecondFactorDto.prototype, "scope", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], BackendResetSecondFactorDto.prototype, "endSessions", void 0);
//# sourceMappingURL=backend-reset-second-factor.dto.js.map